import SignInCardCommon, { SignInCardCommonProps } from "../SignInCardCommon";

type Props = SignInCardCommonProps;

export default function SignInCardChildAddParentByCode(props: Props) {
  return (
    <SignInCardCommon
      headerMessage={`${props.action} to link your account to your parent's`}
      {...props}
    />
  );
}
